import { UNIFIED_DESTINATIONS } from "../unifiedSearchMockup/demoFixtures";
import { fetchHubwayzDestinations } from "../../services/hubwayzHotelsApi";

function norm(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

/**
 * Build a SearchContext `location` object from a Hubwayz/unified destination pick.
 * Compatible with resolveHubwayzDestinationFromSearchPhrase + hotel searchPhrase builders.
 */
export function buildHubwayzLocationFromDestination(dest) {
  if (!dest) return null;
  const label = String(dest.label || dest.name || dest.hubwayzNameHint || "").trim();
  const cityEn = String(dest.hubwayzNameHint || dest.seoname || dest.name || label).trim();
  const countryCode = String(dest.countryCode || dest.iso2 || "").trim().toUpperCase();
  const countryLabel = String(dest.countryLabel || dest.country || countryCode).trim();
  const rawId = dest.hubwayzLocationId ?? dest.destinationId ?? null;
  const hubwayzLocationId =
    rawId != null && String(rawId).trim() !== "" ? rawId : null;
  const destinationType = dest.destinationType === "hotel" ? "hotel" : "location";

  return {
    fullname: countryLabel ? `${label}, ${countryLabel}` : label,
    name: label,
    city: cityEn,
    country: countryLabel,
    countryCode: countryCode || undefined,
    iso2: countryCode || undefined,
    hubwayzLocationId: hubwayzLocationId ?? undefined,
    hubwayzNameHint: dest.seoName || dest.hubwayzNameHint || cityEn,
    destinationType,
    entityType: dest.entityType || undefined,
    hotelserched: false,
    _supplier: "hubwayz",
  };
}

export function filterUnifiedHubwayzDestinations(query, limit = 12) {
  const q = norm(query);
  if (!q || q.length < 1) {
    return UNIFIED_DESTINATIONS.filter((d) => d.hubwayzLocationId != null).slice(
      0,
      limit
    );
  }
  return UNIFIED_DESTINATIONS.filter((d) => {
    if (d.hubwayzLocationId == null && !d.hubwayzNameHint) return false;
    const hay = [
      d.label,
      d.hubwayzNameHint,
      d.id,
      d.countryLabel,
      d.countryCode,
      d.flightIata,
    ]
      .map(norm)
      .join(" ");
    return hay.includes(q);
  }).slice(0, limit);
}

/**
 * Optional remote Hubwayz city list for a country (ISO2), filtered by query.
 */
export async function searchHubwayzDestinationsRemote(countryCode, query, limit = 12) {
  const cc = String(countryCode || "").trim().toUpperCase();
  if (!cc || !/^[A-Z]{2}$/.test(cc)) return [];
  const q = norm(query);
  try {
    const res = await fetchHubwayzDestinations(cc);
    const list = Array.isArray(res?.destinations) ? res.destinations : [];
    const mapped = list
      .filter((d) => d?.id != null)
      .map((d) => ({
        id: `hwz-${d.id}`,
        label: d.name || d.seoname || String(d.id),
        countryCode: cc,
        countryLabel: cc,
        hubwayzNameHint: d.seoname || d.name,
        hubwayzLocationId: d.id,
        name: d.name,
        seoname: d.seoname,
      }));
    if (!q) return mapped.slice(0, limit);
    return mapped
      .filter((d) => {
        const hay = [d.label, d.hubwayzNameHint, d.seoname].map(norm).join(" ");
        return hay.includes(q);
      })
      .slice(0, limit);
  } catch {
    return [];
  }
}
